import * as React from 'react';
import { d3SectorsEarningsChart, SelectionState } from '../../../interface/EmployeeReportInterface';
import { LabelList, Cell, PieChart, Pie, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import styled from 'styled-components'
import { numberFormat, numberWithCommas, checkSectorData, numberRound } from '../../Common/Helpers';

const InsufficientTextContainer = styled.div`
    width:100%;
    height:350px;
    text-align:center;
`;
const InsufficientText = styled.strong`
    line-height:350px;
    vertical-align:middle;
`;

export class SectorsEarningsChart extends React.Component<d3SectorsEarningsChart & SelectionState, {}> {
    render() {

        let theWidth = (this.props.normal_or_large === 0) ? 440 : 900;
        let theHeight = (this.props.normal_or_large === 0) ? 350 : 600;
        let theMargin = (this.props.normal_or_large === 0) ? { top: 20, right: 0, left: 35, bottom: 0 } :
            { top: 25, right: 0, left: 75, bottom: 45 };

        let iconSize = (this.props.normal_or_large === 0) ? 14 : 24;
        let payload = [];
        let theFontsize = (this.props.normal_or_large === 0) ? 11 : 14;

        let bardata = this.props.EmployeeProfile2.filter(x => x.employee.trim() == this.props.selected_employee_type && x.year === this.props.slider_year);
        let piedata = this.props.EmployeeProfile2.filter(x => x.employee.trim() == this.props.selected_employee_type && x.year === this.props.slider_year);


        const fill = ["#fcb045", "#8884d8", "#82ca9d", "#5cbae6", "#b6d957", "#fac364", "#8cd3ff", "#d998cb", "#f2d249", "#93b9c6", "#ccc5a8", "#52bacc", "#dbdb46", "#98aafb"];
        const makeUp = (data) => {
            let missing = ["Private", "Public", "Education"];
            let sectors = [];
            if (data.length < 3) {
                //if there's no such all/grad/postdoc data at a certain year, then no need to make up missing sector
                if (data.length == 0 || checkSectorData(data) == 0) return;
                //data has sectors missing
                data.forEach((d) => {
                    sectors.push(d.sector);
                });
                missing=missing.filter((sec) => {
                    return sectors.indexOf(sec) < 0;
                });
                missing.forEach((missingSector) => {
                    const d = {
                        count: 0,
                        employee: data[0].employee,
                        per: 0,
                        sector: missingSector,
                        wage: 0,
                        year: data[0].year
                    };
                    data.push(d);
                });
            }
        }
        
        //make up missing sectors for pie and bar data
        makeUp(piedata);
        makeUp(bardata);

        const publicPercentage = checkSectorData(piedata) !==0&& piedata.filter(d => d.sector === 'Public')[0].per;
        const privatePercentage = checkSectorData(piedata)!==0&&piedata.filter(d => d.sector === 'Private')[0].per;
        const eduPercentage = checkSectorData(piedata)!==0&&piedata.filter(d => d.sector === 'Education')[0].per;

        return <div className="row">
                   <div className="col-md-5 emp--sector_earnings">
                        <h5>Number of Employees By Sector</h5>
                {
                    checkSectorData(piedata) === 0
                        ? <InsufficientTextContainer>
                            <InsufficientText>Insufficient data to populate the chart.</InsufficientText>
                        </InsufficientTextContainer>
                        : <PieChart width={theWidth} height={theHeight} margin={theMargin}>
                            <Tooltip formatter={numberWithCommas}/>
                            <Pie data={piedata} dataKey={"count"} nameKey={"sector"} cx="50%" cy="50%" innerRadius={20} outerRadius={100}
                                label={(x) => {
                                    //label overlay issue
                                    let shiftY=0;
                                    if (publicPercentage === 0 && privatePercentage === 0 && x.sector === "Public") {
                                        shiftY = -10;                              
                                    }
                                    if (publicPercentage === 0 && eduPercentage === 0 && x.sector === "Public") {
                                        shiftY = -10;
                                    }
                                    if (privatePercentage === 0 && eduPercentage === 0 && x.sector === "Education") {
                                        shiftY = -10;
                                    }
                                    const RADIAN = Math.PI / 180;
                                    const radius = 25 + x.innerRadius + (x.outerRadius - x.innerRadius);
                                    const posX = x.cx + radius * Math.cos(-x.midAngle * RADIAN);
                                    const posY = x.cy + radius * Math.sin(-x.midAngle * RADIAN);
                                    return <text x={posX} y={posY + shiftY} fill={x.fill}
                                        textAnchor={posX > x.cx ? "start" : "end"}
                                        dominantBaseline="central"
                                        fontSize="12px">{`${x.sector} : ${x.count !== 0 ? numberRound(x.count, 2) : 'NA'} ${x.per !== 0 ? "(" + (x.per * 100).toFixed(0) + '%)' : ''}`}</text>
                                }}
                                isAnimationActive={false}

                            >
                                 {piedata.map((entry, index) => <Cell fill={fill[index % fill.length]} />)}
                            </Pie>
                                </PieChart>
                        }
                   </div>
                   <div className="col-md-5">
                        <h5>Average Earnings By Sector</h5>

                {
                    checkSectorData(bardata) === 0
                                ? <InsufficientTextContainer>
                                    <InsufficientText>Insufficient data to populate the chart.</InsufficientText>
                                </InsufficientTextContainer>
                                : <BarChart width={theWidth} height={theHeight} data={bardata}
                                    margin={theMargin}>
                                    <XAxis dataKey="sector" tick={{ fontSize: theFontsize }} />
                                    <YAxis
                                        tickFormatter={numberFormat}
                                        tick={{ fontSize: theFontsize }} />
                                    <CartesianGrid stroke="#f5f5f5" />
                                    <Tooltip content={<CustomTooltip payload={payload} />} />
                                    <Legend iconType={"square"} height={10} payload={payload}
                                        wrapperStyle={{ fontSize: theFontsize, lineHeight: '80px' }} iconSize={iconSize} />
                                    <Bar barSize={40} dataKey="wage" isAnimationActive={false}>
                                    <LabelList dataKey="wage" position="top" content={<CustomLabelList />}></LabelList>
                                        {bardata.map((entry, index) => <Cell fill={fill[index % fill.length]} />)}

                                </Bar>
                                </BarChart>
                        }

                   </div>
               </div>;
    }
}

const CustomTooltip = (props) => {
    const { payload } = props;
    if (payload !== undefined && payload.length > 0) {
        const the_value = (payload[0].payload.wage == 0) ? "NA" : numberFormat(payload[0].payload.wage);
        return (
            <div style={{ "border": "solid 1px #D3D3D3", "padding": "8px 10px 0 10px", backgroundColor: "white", "opacity":0.9}}><p>{payload[0].payload.sector}</p><p>Wage : {the_value}</p></div>
        )
    }
    return (<div></div>);
};


const CustomLabelList = (props) => {
    const { x, y, fill, value, fontSize } = props;
    const the_value = (value == 0) ? "NA" : numberFormat(value);
    return (
        <text x={x + 20} y={y} dy={-4} fill={fill} fontSize={fontSize} textAnchor="middle">{the_value}</text>
    )
};
